"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _ActivationErrorModal = _interopRequireDefault(require("ui-addon-upgrades/_core/common/components/ActivationErrorModal"));

var _ActivationSuccessModal = _interopRequireDefault(require("ui-addon-upgrades/_core/common/components/ActivationSuccessModal"));

var ActivationModalContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ActivationModalContainer, _Component);

  function ActivationModalContainer() {
    var _this;

    (0, _classCallCheck2.default)(this, ActivationModalContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ActivationModalContainer).call(this));
    _this.handleModalClose = _this.handleModalClose.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ActivationModalContainer, [{
    key: "handleModalClose",
    value: function handleModalClose() {
      var onSuccess = this.props.onSuccess;
      onSuccess();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hasError = _this$props.hasError,
          type = _this$props.type;

      if (hasError) {
        return _react.default.createElement(_ActivationErrorModal.default, null);
      }

      return _react.default.createElement(_ActivationSuccessModal.default, {
        type: type,
        onSuccess: this.handleModalClose
      });
    }
  }]);
  return ActivationModalContainer;
}(_react.Component);

ActivationModalContainer.defaultProps = {
  hasError: false,
  shouldHideSurvey: false,
  onSuccess: _emptyFunction.default
};
ActivationModalContainer.propTypes = {
  hasError: _propTypes.default.bool.isRequired,
  type: _propTypes.default.string.isRequired,
  onSuccess: _propTypes.default.func
};
var _default = ActivationModalContainer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/components/ActivationModalContainer.js
// module id = 772
// module chunks = 5 6